angular.module('myApp.services')
    .service('clientTools', function() {
        var isMobileLayout  = false;
        var isPageReady     = false;
        var serverHost      = window.location.hostname;
        var nodeJsHost      = '';
        var userAgent       = null;
        var options         = {
            'mediaFilesFolder' : '',
            'speedTest' : {
                'download'  : 0,    //mb/s
                'upload'    : 0     //mb/s
            },
            'oeVideoResultsFolder': ''
        };
        if (navigator && ('userAgent' in navigator)) {
            userAgent       = navigator.userAgent;
        }
        var canPlayHtml5Video = function() {
            var tmpVideoTag = document.createElement('video');
            if (!!tmpVideoTag.canPlayType) {
                return tmpVideoTag.canPlayType('video/mp4') ||
                    tmpVideoTag.canPlayType('video/ogg') ||
                    tmpVideoTag.canPlayType('video/webm');
            } else {
                return false;
            }
        };
        var canPlayHtml5Audio = function() {
            var tmpVideoTag = document.createElement('audio');
            if (!!tmpVideoTag.canPlayType) {
                return tmpVideoTag.canPlayType('audio/mpeg') ||
                    tmpVideoTag.canPlayType('audio/ogg');
            } else {
                return false;
            }
        };
        var canPlayVideo                    = canPlayHtml5Video();
        var canPlayAudio                    = canPlayHtml5Audio();
        var setCookie = function(name, value, options) {
            options = options || {};

            var expires = options.expires;

            if (typeof expires == "number" && expires) {
                var d = new Date();
                d.setTime(d.getTime() + expires*1000);
                expires = options.expires = d;
            }
            if (expires && expires.toUTCString) {
                options.expires = expires.toUTCString();
            }

            value = encodeURIComponent(value);

            var updatedCookie = name + "=" + value;

            for(var propName in options) {
                updatedCookie += "; " + propName;
                var propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += "=" + propValue;
                }
            }

            document.cookie = updatedCookie;
        };
        var deleteCookie = function(name) {
            setCookie(name, "", { expires: -1 });
        };

        var makeSpeedTest = function (testUrl, clbk) {
            var start   = 0;
            var end     = 0;
            var binfile = '';

            var testDownload = function() {
                start = new Date().getTime();
                $.ajax({
                    type: "GET",
                    url: testUrl + "?id=" + start,
                    crossDomain: true,
                    success: function(msg) {
                        binfile     = msg;
                        end         = new Date().getTime();
                        var diff    = (end - start) / 1000;
                        var bytes   = msg.length;
                        var speed   = (bytes / diff) / 1024 / 1024 * 8;
                        var speed   = Math.round(speed*100)/100;
                        options.speedTest.download = speed;
                    },
                    complete: function(xhr, textStatus) {
                        if (textStatus == 'success') {
                            testUpload();
                        } else if (clbk) {
                            clbk();
                        }
                    }
                });
            };

            var testUpload = function() {
                start = new Date().getTime();
                $.ajax({
                    type: "POST",
                    url: testUrl +"?id=" + start,
                    data: binfile,
                    crossDomain: true,
                    success: function(msg) {
                        end         = new Date().getTime();
                        var diff    = (end - start) / 1000;
                        var bytes   = binfile.length;
                        var speed   = (bytes / diff) / 1024 / 1024 * 8;
                        var speed   = Math.round(speed*100)/100;
                        options.speedTest.upload = speed;
                    },
                    complete: function (xhr, textStatus) {
                        if (clbk) {
                            clbk();
                        }
                    }
                });
            };
            testDownload();
        };

        this.makeSpeedTest = function (fileSize, clbk) {
            var host = this.getNodeJsHost();
            if (host == '') {
                host = serverHost;
            }
            if (!fileSize) {
                fileSize = '200';
            }
            var speedTestUrl = host + '/internet-speed/' + fileSize;
            makeSpeedTest(speedTestUrl, clbk);
        };
        this.getInternetSpeed = function () {
            return options.speedTest;
        };
        this.setInternetSpeed = function (speed) {
            if (('download' in speed) && ('upload' in speed)) {
                options.speedTest = speed;
            }
        };
        this.setOptions = function(opts) {
            if (opts) {
                try {
                    opts = JSON.parse(opts);
                    options = angular.extend({}, options, opts);
                } catch (e) {console.log("Error in parse json options in clientTools service", opts)}
            }
        };
        this.getOptions = function(name) {
            if (name && (name in options)) {
                return options[name];
            }
            return options;
        };
        this.setIsMobileLayout = function() {
            isMobileLayout = true;
        };
        this.isMobileLayout = function() {
            return isMobileLayout;
        };
        this.setIsPageReady = function() {
            isPageReady = true;
        };
        this.isPageReady = function() {
            return isPageReady;
        };
        this.setServerHost = function(host) {
            serverHost = host;
        };
        this.getServerHost = function() {
            return serverHost;
        };
        this.setNodeJsHost = function(host) {
            nodeJsHost = host;
        };
        this.getNodeJsHost = function() {
            return nodeJsHost;
        };
        this.isCanPlayHtml5Video = function() {
            return canPlayVideo;
        };
        this.setCookie = function(name, value, options) {
            if (name && value) {
                setCookie(name, value, options);
            }
        };
        this.deleteCookie = function(name) {
            if (name) {
                deleteCookie(name);
            }
        };
        this.getRandomInt = function(from, to) {
            return Math.floor(Math.random()*(to-from+1))+ from;
        };
        this.isIOS = function() {
            return userAgent.match(/(iPad|iPhone|iPod)/gi);
        };
        this.isIOSAndAndroidPlatform = function() {
            return userAgent.match(/(iPad|iPhone|iPod|Android)/gi);
        };
        this.isIE = function() {
            return (userAgent.match(/(Trident|MSIE)/gi) ? true : false);
        };
        this.isEdge = function() {
            return (userAgent.match(/(Edge\/\d+)/gi) ? true : false);
        };
        this.isSafari = function() {
            return userAgent.indexOf('Safari') != -1 && userAgent.indexOf('Chrome') == -1;
        };
        this.isMac = function() {
            return navigator.platform.match(/Mac/i) ? true : false;
        };
        this.isWin = function() {
            return navigator.platform.match(/Win/i) ? true : false;
        };

        this.hasSupportGetUserMedia = function() {
            if (navigator && ('mediaDevices' in navigator) && ('getUserMedia' in navigator.mediaDevices) && !this.isSafari()) {
                return true;
            }
            return false;
        };
        this.isAVResponseEnabled = function() {
            if (this.isIE() || this.isEdge() || (this.isSafari() && (this.isMac() || this.isWin()))) {
                return false;
            }
            return true;
        };
        this.rgb2hex = function (rgb) {
            rgb = rgb.match(/\d+/g);
            return "#" +
                ("0" + parseInt(rgb[0], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2);
        }
    });